export default "__VITE_ASSET__7d54a8b7__"